import { Card, Flex, Typography } from '@iheartjane/reefer';

export const ROW_COPY = {
  best_selling: {
    header: 'Best Sellers',
    subheader: 'Display your best selling products automatically.',
  },
  sale: {
    header: 'On Sale',
    subheader: 'Display your discounted products automatically.',
  },
  specials: {
    header: 'Deals',
    subheader: 'Display all active deals in a new shoppable menu row.',
  },
};

export const DynamicRowCard = ({ row_type }: { row_type: string }) => {
  const { header, subheader } =
    ROW_COPY[row_type as keyof typeof ROW_COPY] ?? {};

  if (!header && !subheader) return null;

  return (
    <Card flat mb={24}>
      <Card.Content background="grays-ultralight">
        <Flex flexDirection="column" p={8}>
          <Typography variant="body-semibold">{header}</Typography>
          <Typography>{subheader}</Typography>
        </Flex>
      </Card.Content>
    </Card>
  );
};
